import {
  Button,
  FormField,
  Modal,
  RangeDatePicker,
  TextInput,
  Variants
} from "@sede-x/shell-ds-react-framework";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import { TInboundCargoSearchCriteria } from "./tracker.types";

export const InboundCargoSearch = ({
  open,
  searchCriteria,
  onClose,
  onSubmit
}: {
  open: boolean;
  searchCriteria: TInboundCargoSearchCriteria;
  onClose: () => void;
  onSubmit: (elm: TInboundCargoSearchCriteria) => void;
}) => {
  const [localSearchCriteria, setLocalSearchCriteria] =
    useState<TInboundCargoSearchCriteria>(searchCriteria);

  const disabledDate = (current: Dayjs) =>
    current
      ? current.isBefore(new Date("2024-08-01"), "date") || current.isAfter(new Date(), "date")
      : false;
  return (
    <Modal
      title="Search inbound cargo updae request"
      width={"800px"}
      height={"600px"}
      mask={true}
      maskClosable={false}
      open={open}
      onClose={onClose}>
      <div>
        <FormField size={"medium"} label="Requested between">
          <RangeDatePicker
            picker="date"
            format="MM/DD/YYYY"
            allowClear={true}
            disabledDate={disabledDate}
            autoFocus
            value={[dayjs(localSearchCriteria.startDate), dayjs(localSearchCriteria.endDate)]}
            onChange={values => {
              setLocalSearchCriteria(c => ({
                ...c,
                startDate: values?.[0]?.toISOString() ?? "",
                endDate: values?.[1]?.toISOString() ?? ""
              }));
            }}
          />
        </FormField>
        <FormField size={"medium"} label="Cargo Id">
          <TextInput
            placeholder="Comma seperated cargo ids"
            value={localSearchCriteria.cargoId}
            onChange={e =>
              setLocalSearchCriteria(c => ({
                ...c,
                cargoId: e.target.value
              }))
            }
          />
        </FormField>
        <FormField size={"medium"} label="Cargo name">
          <TextInput
            placeholder="Comma seperated cargo names"
            value={localSearchCriteria.cargoName}
            onChange={e =>
              setLocalSearchCriteria(c => ({
                ...c,
                cargoName: e.target.value
              }))
            }
          />
        </FormField>
        <FormField size={"medium"} label="Delivery Id">
          <TextInput
            placeholder="Comma seperated Delivery Ids"
            value={localSearchCriteria.deliveryIds}
            onChange={e =>
              setLocalSearchCriteria(c => ({
                ...c,
                deliveryIds: e.target.value
              }))
            }
          />
        </FormField>
        <div style={{ paddingBottom: "120px" }}></div>
        <div className="from-button-wrap">
          <Button variant={Variants.Outlined} onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" onClick={() => onSubmit(localSearchCriteria)}>
            Search
          </Button>
        </div>
      </div>
    </Modal>
  );
};
